var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useReactiveVar } from '@apollo/client';
import { styled } from '@material-ui/core/styles';
import { Button, Typography } from '@material-ui/core';
import _Logo from '../components/primitive/KaizenPlatformLogo';
import { SPACING_UNIT, SPACING_REGULAR } from '../constant/spacing';
import { subText } from '../constant/color';
import { gridLayoutContainer, gridLayoutItem } from '../styleUtility/gridLayout';
import { currentUserVar, errorsVar } from '../../cache';
import { commands } from '../../operations/commands';
var FatalErrorScreen = function (_a) {
    var className = _a.className;
    var history = useHistory();
    var currentUser = useReactiveVar(currentUserVar);
    var errors = useReactiveVar(errorsVar);
    return errors && errors.some(function (e) { return e.name === 'Fatal'; }) ? (React.createElement(Root, { className: className },
        React.createElement(Logo, null),
        React.createElement(Title, { variant: "h4", gutterBottom: true }, "Oops, Something went really wrong"),
        errors.map(function (e) {
            if (e.name === 'Fatal')
                return React.createElement(Message, { variant: "subtitle1" }, e.message);
        }),
        React.createElement(BackButton, { variant: "contained", color: "primary", onClick: function () {
                commands.disposeErrors();
                commands.disposeLastAccessedOrganization();
                history.push('/');
            } }, "\u623B\u308B"))) : null;
};
var Root = styled('div')(__assign(__assign({}, gridLayoutContainer({
    columns: ['auto'],
    rows: ['auto', 'auto', 'auto', 'auto'],
    areas: [['logo'], ['title'], ['errorMessage'], ['button']],
    alignContent: 'center',
    justifyItems: 'center',
    alignItems: 'flex-start',
})), { marginTop: "-" + SPACING_REGULAR + "px", marginRight: 'auto', marginLeft: 'auto' }));
var Logo = styled(_Logo)(__assign(__assign({}, gridLayoutItem('logo')), { width: 305, marginBottom: SPACING_UNIT * 8 }));
var Title = styled(Typography)(__assign(__assign({}, gridLayoutItem('title')), { marginBottom: SPACING_UNIT * 4, fontWeight: 500, maxWidth: 720 }));
var Message = styled(Typography)(__assign(__assign({}, gridLayoutItem('errorMessage')), { marginBottom: SPACING_UNIT, maxWidth: 720, color: subText }));
var BackButton = styled(Button)(__assign(__assign({}, gridLayoutItem('button')), { marginTop: SPACING_UNIT * 2, minWidth: '150px' }));
export default FatalErrorScreen;
